module.exports = __webpack_public_path__ + "static/media/send-message-in-private.36d5c046.svg";